import { SIGNIN, ERROR } from './actionsTypes';
import { sendResponse } from './request';
import { startRequest, endRequest } from './loading';
import ConfigSite from '../configSite';
import axios from 'axios';

const apiUrl = `${ConfigSite.SERVICE_URL}/users/signin`;

export const signin = (item) => {
  return (dispatch) => {
    dispatch(startRequest())
    return axios.post(`${apiUrl}/`, item)
      .then(response => {
        dispatch(sendResponse(response.status, response.data))
        dispatch(endRequest())
      })
      .catch(error => {
        if (error && error.response) {
          dispatch(errorResponse(error.response.data.message, error.response.data.error, dispatch))
        } else {
          dispatch(errorResponse('Error on Signin', error, dispatch))
        }

        throw(error);
      });
  };
};

/**
 * Thrown an error message to components
 * @param {*} message 
 * @param {*} error 
 * @param {*} dispatch 
 */
export const errorResponse = (message, error, dispatch) => {
  dispatch(sendResponse(error.status, message +': "'+ error + '"'))
  dispatch(endRequest())
  return { type: ERROR, payload: [] }
};

/**
 * 
 * @param {*} data 
 */
export const signinSuccess = (data) => {
  return {
    type: SIGNIN,
    payload: data
  }
};




// WEBPACK FOOTER //
// ./src/actions/signin.js